// Cart-page behaviors: row updates (qty / variation / license), notices, delete
// confirmation, upsells, and the generic "expand row details" toggle.

import { ajaxPost, getAjaxUrl, getNonce } from './lib/ajax.js';
import * as bundleBox from './lib/bundle-box.js';

// === notices ===

function set_cart_notice(type, text) {
    var $wrap = jQuery('.woocommerce-notices-wrapper').first();

    if (!$wrap.length) {
        alert(text);
        return;
    }

    var cls = type === 'error' ? 'woocommerce-error' : 'woocommerce-message';
    $wrap.html('<div class="' + cls + '" role="alert">' + String(text) + '</div>');
}

// === blink animations ===

function blinkCartButton() {
    var $button = jQuery('.cart-button');
    if (!$button.length || !$button[0]) return;

    $button.removeClass('blink');
    // Force reflow to restart the animation.
    void $button[0].offsetWidth;

    $button.addClass('blink');
    setTimeout(function() { $button.removeClass('blink'); }, 600);
}

function blinkDiscount() {
    var $info = jQuery('.zd-discount-info');
    if (!$info.length) return;

    $info.removeClass('blink');
    void $info[0].offsetWidth;
    $info.addClass('blink');
    setTimeout(function() { $info.removeClass('blink'); }, 600);
}

// === cart-page refresh (re-renders form + summary in place) ===

var cart_page_refresh_token = 0;
var cart_remove_in_flight = false;

function refresh_cart_page_html() {
    if (!jQuery('body').hasClass('woocommerce-cart')) {
        return jQuery.Deferred().resolve().promise();
    }

    var refresh_token = ++cart_page_refresh_token;

    return jQuery.get(window.location.href).done(function(html) {
        if (refresh_token !== cart_page_refresh_token) {
            return;
        }

        var $doc = jQuery(jQuery.parseHTML(html));

        var $new_page = $doc.find('.zd-max-width').first();
        var $old_page = jQuery('.zd-max-width').first();

        var $new_header_row = $doc.find('.zd-max-width > .row').first();
        var $old_header_row = jQuery('.zd-max-width > .row').first();

        var $new_form = $doc.find('#zd-cart-page-form').first();
        var $old_form = jQuery('#zd-cart-page-form').first();

        var $new_summary_box = $doc.find('.zd-shop-summary-box').first();
        var $old_summary_box = jQuery('.zd-shop-summary-box').first();

        var $new_notices = $doc.find('.woocommerce-notices-wrapper').first();
        var $old_notices = jQuery('.woocommerce-notices-wrapper').first();

        if ($new_notices.length) {
            if ($old_notices.length) {
                $old_notices.replaceWith($new_notices);
            } else if ($old_page.length) {
                $old_page.prepend($new_notices);
            }
        }

        if ($new_header_row.length && $old_header_row.length) {
            $old_header_row.replaceWith($new_header_row);
        }

        if ($new_form.length && $old_form.length) {
            $old_form.replaceWith($new_form);

            if ($new_summary_box.length && $old_summary_box.length) {
                $old_summary_box.replaceWith($new_summary_box);
            }
        } else if ($new_page.length && $old_page.length) {
            $old_page.replaceWith($new_page);
        }

        bundleBox.restore('cart');
        sync_all_qty_buttons();

        jQuery(document.body).trigger('updated_wc_div');
    });
}

// === row update payload assembly ===

function set_cart_row_loading($row, is_loading) {
    if (!$row || !$row.length) return;

    $row.css('opacity', is_loading ? '0.5' : '1');
    $row.find('select, input, button, a.zd-remove-item').css('pointer-events', is_loading ? 'none' : '');
    $row.find('select, input, button').prop('disabled', !!is_loading);

    if (!is_loading) {
        sync_qty_button_state($row.find('.zd-qty-wrapper').first());
    }
}

function collect_cart_variations($row) {
    var out = {};

    $row.find('.zd-cart-variation-select').each(function() {
        var $field = jQuery(this);
        var attribute_name = String($field.data('attribute-name') || '');
        var value = String($field.val() || '');

        if (!attribute_name) {
            var name_attr = String($field.attr('name') || '');
            var match = name_attr.match(/variation\]\[(.*?)\]/);

            if (match && match[1]) {
                attribute_name = String(match[1]);
                if (attribute_name.indexOf('attribute_') !== 0) {
                    attribute_name = 'attribute_' + attribute_name;
                }
            }
        }

        if (attribute_name && value) out[attribute_name] = value;
    });

    return out;
}

function collect_cart_bundle_variations($row) {
    var out = {};

    $row.find('.zd-bundle-child-row').each(function() {
        var $child_row = jQuery(this);
        var bundle_row_key = String($child_row.data('bundle-row-key') || '');
        var child_id = parseInt($child_row.data('child-id'), 10) || 0;
        var row_key = bundle_row_key || String(child_id);

        if (!row_key) return;

        var attrs = {};

        $child_row.find('.zd-cart-bundle-child-select').each(function() {
            var $field = jQuery(this);
            var attribute_name = String($field.data('attribute-name') || '');
            var value = String($field.val() || '');

            if (attribute_name && value) attrs[attribute_name] = value;
        });

        if (Object.keys(attrs).length) out[row_key] = attrs;
    });

    return out;
}

function submit_cart_row_update($row, $trigger) {
    var cart_item_key = String($row.data('cart-item-key') || '');
    if (!cart_item_key) return;

    var $qty_input = $row.find('.zd-cart-qty-input').first();
    var quantity = $qty_input.length ? (parseInt($qty_input.val(), 10) || 1) : 1;
    quantity = Math.max(1, Math.min(99, quantity));

    if ($qty_input.length) $qty_input.val(quantity);

    var $license_select = $row.find('.zd-license-select').first();
    var license_duration = $license_select.length ? (parseInt($license_select.val(), 10) || 0) : 0;

    var payload = {
        cart_item_key: cart_item_key,
        quantity: quantity,
        license_duration: license_duration,
    };

    var variations = collect_cart_variations($row);
    var bundle_variations = collect_cart_bundle_variations($row);

    if (Object.keys(variations).length) payload.variations = variations;
    if (Object.keys(bundle_variations).length) payload.bundle_variations = bundle_variations;

    set_cart_row_loading($row, true);

    ajaxPost('zd_update_cart', payload)
        .done(function(response) {
            if (!response || !response.success) {
                var msg = response && response.data && response.data.message
                    ? response.data.message
                    : 'Could not update cart item.';

                set_cart_notice('error', msg);
                set_cart_row_loading($row, false);
                return;
            }

            var should_remember_bundle_box = $trigger && $trigger.hasClass('zd-cart-bundle-child-select');

            if (should_remember_bundle_box) {
                bundleBox.remember(cart_item_key);
            }

            refresh_cart_page_html().always(function() {
                jQuery(document.body).trigger('wc_fragment_refresh');
                jQuery(document.body).trigger('update_checkout');
            });
        })
        .fail(function(jqXHR, text_status, error_thrown) {
            console.error('AJAX cart update failed:', text_status, error_thrown);
            set_cart_notice('error', 'Could not update cart item.');
            set_cart_row_loading($row, false);
        });
}

// === quantity button state ===

function sync_qty_button_state($wrapper) {
    if (!$wrapper || !$wrapper.length) return;

    var $input = $wrapper.find('.zd-wishlist-qty-input, .zd-cart-qty-input').first();
    if (!$input.length) return;

    var val = parseInt($input.val(), 10) || 1;
    var min = parseInt($input.attr('min'), 10) || 1;
    var max = parseInt($input.attr('max'), 10) || 99;

    $wrapper.find('.zd-qty-minus').prop('disabled', val <= min);
    $wrapper.find('.zd-qty-plus').prop('disabled', val >= max);
}

function sync_all_qty_buttons() {
    jQuery('.cart-item-row .zd-qty-wrapper, .wishlist-item-row .zd-qty-wrapper').each(function() {
        sync_qty_button_state(jQuery(this));
    });
}

// === event bindings ===

function bind_quantity_buttons() {
    jQuery(document).on('click', '.zd-qty-btn', function(e) {
        e.preventDefault();

        var $btn = jQuery(this);
        if ($btn.prop('disabled')) return;

        var action = String($btn.data('action') || '');
        var $wrapper = $btn.closest('.zd-qty-wrapper');
        var $input = $wrapper.find('.zd-wishlist-qty-input, .zd-cart-qty-input').first();

        if (!$input.length) return;

        var val = parseInt($input.val(), 10) || 1;
        var min = parseInt($input.attr('min'), 10) || 1;
        var max = parseInt($input.attr('max'), 10) || 99;

        if (action === 'plus' && val < max) val++;
        if (action === 'minus' && val > min) val--;

        val = Math.max(min, Math.min(max, val));

        $input.val(val);
        sync_qty_button_state($wrapper);
        $input.trigger('change');
    });
}

function bind_row_changes() {
    jQuery(document).on(
        'change',
        '.cart-item-row .zd-cart-variation-select, .cart-item-row .zd-cart-bundle-child-select, .cart-item-row .zd-license-select',
        function() {
            submit_cart_row_update(jQuery(this).closest('.cart-item-row'), jQuery(this));
        }
    );

    jQuery(document).on('change', '.cart-item-row .zd-cart-qty-input', function() {
        sync_qty_button_state(jQuery(this).closest('.zd-qty-wrapper'));

        var $row = jQuery(this).closest('.cart-item-row');
        var qty_timer = $row.data('zd_qty_timer');

        if (qty_timer) clearTimeout(qty_timer);

        qty_timer = setTimeout(function() {
            submit_cart_row_update($row);
        }, 250);

        $row.data('zd_qty_timer', qty_timer);
    });
}

function bind_clear_cart_flow() {
    jQuery(document).on('click', '.zd-clear-cart:not(.disabled)', function(e) {
        e.preventDefault();
        jQuery('#clear-cart-confirm').fadeIn(150);
    });

    jQuery(document).on('click', '#clear-cart-confirm .confirm-clear-cart', function(e) {
        e.preventDefault();

        var $btn = jQuery(this);
        $btn.prop('disabled', true);

        var clear_payload = {};
        var wc_cart_nonce = jQuery('[name="woocommerce-cart-nonce"]').val();
        if (wc_cart_nonce) {
            clear_payload['woocommerce-cart-nonce'] = wc_cart_nonce;
        }

        ajaxPost('zd_clear_cart', clear_payload)
            .done(function(response) {
                if (!response || !response.success) {
                    var msg = response && response.data && response.data.message
                        ? response.data.message
                        : 'Could not clear cart.';

                    set_cart_notice('error', msg);
                    return;
                }

                cart_page_refresh_token++;

                refresh_cart_page_html().always(function() {
                    jQuery(document.body).trigger('wc_fragment_refresh');
                    jQuery(document.body).trigger('update_checkout');
                });
            })
            .fail(function(jqXHR, text_status, error_thrown) {
                console.error('AJAX clear cart failed:', text_status, error_thrown, jqXHR && jqXHR.responseText);

                var msg = 'Could not clear cart.';
                if (jqXHR && jqXHR.status === 400 && String(jqXHR.responseText || '').trim() === '0') {
                    msg = 'Clear cart is unavailable. Please reload the page and try again.';
                }

                set_cart_notice('error', msg);
            })
            .always(function() {
                $btn.prop('disabled', false);
                jQuery('#clear-cart-confirm').fadeOut(150);
            });
    });
}

function bind_delete_flow() {
    // First .zd-remove-item handler: ajax-driven (newer style).
    jQuery(document).on('click', '.cart-item-row .zd-remove-item, .zd-cart-upsells .zd-remove-item', function(e) {
        e.preventDefault();

        var $link = jQuery(this);
        var is_checkout_upsell = $link.closest('.zd-cart-upsells').length > 0;
        var cart_item_key = String(
            $link.data('cart-item-key') ||
            $link.closest('.cart-item-row').data('cart-item-key') ||
            $link.closest('[data-upsell-id]').find('.zd-remove-item').data('cart-item-key') ||
            $link.closest('.zd-qty-wrapper').data('cart-item-key') ||
            ''
        );
        if (!cart_item_key) return;

        var $popup = jQuery('#delete-cart-item');
        var $confirm_btn = $popup.find('.confirm-delete-cart-item');

        $popup.data('cart-item-key', cart_item_key);
    $confirm_btn.attr('data-cart-item-type', is_checkout_upsell ? 'checkout-upsell' : 'cart');
        $confirm_btn.attr('data-cart-item-key', cart_item_key);

        $popup.fadeIn(150);
    });

    jQuery(document).on('click', '#delete-cart-item .confirm-delete-cart-item', function(e) {
        e.preventDefault();

        var $btn = jQuery(this);
        if ($btn.prop('disabled') || cart_remove_in_flight) return;

        var item_type = String($btn.data('cart-item-type') || '');

        if (item_type !== 'cart' && item_type !== 'checkout-upsell') return;

        var $popup = jQuery('#delete-cart-item');
        var cart_item_key = String(
            $popup.data('cart-item-key') ||
            $btn.data('cart-item-key') ||
            ''
        );
        if (!cart_item_key) return;

        cart_remove_in_flight = true;
        $btn.prop('disabled', true);
        $popup.removeData('cart-item-key');
        $btn.removeData('cart-item-key').attr('data-cart-item-key', '');

        ajaxPost('zd_remove_upsell_from_cart', { cart_item_key: cart_item_key })
            .done(function(response) {
                if (!response || !response.success) {
                    var msg = response && response.data && response.data.message
                        ? response.data.message
                        : 'Could not remove item from cart.';

                    set_cart_notice('error', msg);
                    return;
                }

                if (item_type === 'checkout-upsell' || jQuery('body').hasClass('woocommerce-checkout')) {
                    window.location.reload();
                    return;
                }

                refresh_cart_page_html().always(function() {
                    jQuery(document.body).trigger('wc_fragment_refresh');
                    jQuery(document.body).trigger('update_checkout');
                });
            })
            .fail(function(jqXHR, text_status, error_thrown) {
                console.error('AJAX cart remove failed:', text_status, error_thrown);
                set_cart_notice('error', 'Could not remove item from cart.');
            })
            .always(function() {
                cart_remove_in_flight = false;
                $btn.prop('disabled', false);
                $popup.fadeOut(150);
            });
    });
}

function bind_info_popups() {
    jQuery(document).on('click', '.license-duration-info', function(e) {
        e.preventDefault();

        var $trigger = jQuery(this);

        var multiplier = parseInt($trigger.attr('data-multiplier') || $trigger.data('multiplier') || 0, 10);

        if (!multiplier || multiplier < 1) {
            var $row = $trigger.closest(
                '.cart-item-row, .wishlist-item-row, .checkout-item-row, .woocommerce-cart-form, form'
            );
            var $select = $row.find('.zd-license-select, .zd-wishlist-license-select').first();
            multiplier = parseInt($select.attr('data-multiplier') || $select.data('multiplier') || 0, 10) || 1;
        }

        multiplier = Math.max(1, multiplier);

        var line = multiplier + ' license' + (multiplier === 1 ? '' : 's');
        jQuery('#license-multiplier-info').text(line);

        jQuery('#license-info').fadeIn(150);
    });

    jQuery(document).on('click', '.shipping-info', function(e) {
        e.preventDefault();
        jQuery('#shipping-info').fadeIn(150);
    });

    jQuery(document).on('click', '.zd-popup-cancel', function() {
        jQuery('.zd-popup-overlay').fadeOut(150);
    });
}

function bind_upsells() {
    jQuery(document).on('click', '.zd-add-upsell', function(e) {
        e.preventDefault();

        var btn = jQuery(this);
        var product_id = btn.data('product-id');

        if (btn.prop('disabled')) return;

        btn.prop('disabled', true).text('Adding...');

        jQuery.ajax({
            url: getAjaxUrl(),
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'zd_add_upsell_to_cart',
                product_id: product_id,
                quantity: 1,
            },
            success: function(response) {
                if (response.success) {
                    window.location.reload();
                    return;
                }
                console.warn('Extras add failed:', response);
                btn.text('Add to Cart').prop('disabled', false);
                alert((response.data && response.data.message) || 'Could not add product.');
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', status, error);
                btn.text('Add to Cart').prop('disabled', false);
                alert('Could not add this product');
            }
        });
    });
}

function mark_already_added_upsells() {
    if (!window.zd_ajax_object || !window.zd_ajax_object.cart_ids) return;

    jQuery('.zd-add-upsell').each(function() {
        var btn = jQuery(this);
        var id = parseInt(btn.data('product-id'));

        if (window.zd_ajax_object.cart_ids.includes(id)) {
            btn.text('Added')
                .prop('disabled', true)
                .css({
                    background: '#ddd',
                    color: '#666',
                    cursor: 'not-allowed'
                });
        }
    });
}

function bind_expand_button() {
    jQuery(document).on('click', '.zd-cart-expand-button', function() {
        var target_class = jQuery(this).data('target');
        if (!target_class) return;

        var mode = jQuery(this).data('mode') || 'toggle';

        if (mode === 'show') {
            jQuery('.' + target_class).show();
            jQuery(this).hide();
        }

        var $container = jQuery('.' + target_class);
        $container.toggleClass('zd-expanded');

        jQuery(this).find('i').toggleClass('rotated');
    });
}

function bind_added_to_cart_blink() {
    jQuery(document.body).on('added_to_cart', function() {
        blinkCartButton();
    });
}

function trigger_initial_fragment_refresh() {
    if (!jQuery('body').hasClass('single-product')) {
        jQuery(document.body).trigger('wc_fragment_refresh');
    }
}

// Exported so other modules / debug code can poke if needed.
export { blinkDiscount };

export function init() {
    bind_added_to_cart_blink();
    bind_quantity_buttons();
    sync_all_qty_buttons();
    bind_row_changes();
    bind_clear_cart_flow();
    bind_delete_flow();
    bind_info_popups();
    bind_upsells();
    bind_expand_button();
    mark_already_added_upsells();
    trigger_initial_fragment_refresh();
}
